import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { memoGeneric } from '@/js/libs/memo';
import { Tab, Title } from './styled';
export const TabItem = memoGeneric(function TabItem({ item, active, onTabChange }) {
    const handleClick = useCallbackRef(() => {
        onTabChange(item.id);
    });
    const dataTestId = useMemo(() => item.dataTestId || `${item.id}-tab-${active ? 'active' : 'inactive'}`, [item.dataTestId, item.id, active]);
    if (item.hidden) {
        return null;
    }
    return (_jsx(Tab, { active: active, onClick: handleClick, "data-testid": dataTestId, "data-active": active, children: _jsx(Title, { active: active, children: item.title }) }));
});
